import { createFileRoute } from '@tanstack/react-router';
import { createColumnHelper } from '@tanstack/react-table';
import api from '@/api';
import type { components } from '@/api/qraft/schema';
import { createTablePage } from '~/components/ui/createTablePage';
import { LIST_PAGE_SIZE } from '~/components/ui/Pagination';

type CampaignItem = components['schemas']['CampaignItem'];

const columnHelper = createColumnHelper<CampaignItem>();

const columns = [
  columnHelper.accessor('id', {
    header: 'ID',
  }),
  columnHelper.accessor((row) => row.domain, {
    id: 'domain',
    header: 'Domain',
  }),
  columnHelper.accessor((row) => row.group_id, {
    id: 'group_id',
    header: 'Group',
  }),
  columnHelper.accessor((row) => row.language, {
    id: 'language',
    header: 'Language',
  }),
];

const CampaignsList = createTablePage<CampaignItem, '/campaigns/$campaignId'>({
  name: 'Campaigns',
  useData: (page: number) => {
    return api.getCampaigns.useQuery({
      query: {
        limit: LIST_PAGE_SIZE,
        offset: LIST_PAGE_SIZE * page,
      },
    });
  },
  columns: columns,
  itemBaseUrl: '/campaigns/$campaignId',
  getParams: (row) => ({ campaignId: String(row.id) }),
});

export const Route = createFileRoute('/_admin/campaigns/')({
  component: CampaignsList,
});
